import React from 'react';
import TopHeaderNavigation from './navigations/TopHeaderNavigation';
import LanguageSelector from '../shared/LanguageSelector';
import MobileTopHeader from './MobileTopHeader';
export default function TopHeader(_ref) {
  var appProps = _ref.appProps;
  var navWrapper = /*#__PURE__*/React.createElement("div", {
    className: "navigation flex-1"
  }, /*#__PURE__*/React.createElement(TopHeaderNavigation, {
    appProps: appProps,
    navigation: appProps.navigation.top_header_menu,
    navClass: "top-header-navigation ".concat(appProps.currentDevice != 'desktop' && 'mobile animated fadeIn')
  }));
  if (appProps.currentDevice != 'desktop') navWrapper = /*#__PURE__*/React.createElement(MobileTopHeader, {
    appProps: appProps,
    navigation: appProps.navigation.top_header_menu
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, (appProps.languages.length > 1 || appProps.navigation.top_header_menu) && /*#__PURE__*/React.createElement("div", {
    className: "top_header",
    style: {
      backgroundColor: appProps.frontendStyles.topHeader.backgroundColor,
      height: appProps.currentDevice != 'desktop' ? '100%' : 40
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "main-container",
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "top_header_contents",
    style: {
      height: '100%'
    }
  }, appProps.navigation.top_header_menu && navWrapper, appProps.languages.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: "languages_wrapper top-header"
  }, /*#__PURE__*/React.createElement(LanguageSelector, {
    appProps: appProps
  }))))));
}